import { Icon, IconProps } from '~/components/Icon/Icon';

export type Don2DProps = IconProps;
export const Don2D = (props: Don2DProps) => (
  <Icon
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <mask
      id="mask0_7759_5911"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="34"
      height="34">
      <rect width="34" height="34" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_7759_5911)">
      <ellipse cx="17.0001" cy="16.9999" rx="13.1364" ry="13.1364" fill="#DDEBFF" />
      <path
        d="M21.1099 12.6402C20.3175 11.9019 19.402 11.3998 18.3547 11.1293V10.8003C18.3547 9.94709 17.6514 9.25546 16.7839 9.25546C15.9163 9.25546 15.2131 9.94709 15.2131 10.8003V10.8909H13.2466C12.6242 10.8911 12.1196 11.3873 12.1196 11.9991V22.1042C12.1196 22.7162 12.6242 23.2124 13.2466 23.2124H15.2136C15.2136 24.058 15.9106 24.7435 16.7704 24.7435H16.7984C17.6582 24.7435 18.3552 24.058 18.3552 23.2124V22.974C19.4025 22.7035 20.318 22.2016 21.1104 21.4631C22.3686 20.3097 22.9887 18.8488 22.9887 17.0804C22.9887 15.3119 22.3686 13.8125 21.1104 12.6399L21.1099 12.6402ZM16.332 20.2331H15.2196V13.8705H16.3138C18.3744 13.8705 19.7605 15.1391 19.7605 17.0421C19.7605 18.9451 18.3929 20.2331 16.3323 20.2331H16.332Z"
        fill="#71ACFF"
      />
    </g>
  </Icon>
);
